var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBloginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 427,
    viewBox: "0 0 427 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.585 306.469l43.385-55.38 31.993.288 18.708 23.557c-2.813 8.747-11.863 28.719-16.036 37.612l-58.213 46.47-5.031-5.139 32.843-51.823c13.951-4.321 15.773-9.504 18.07-13.898 2.297-4.394-7.113-21.083-24.302-8.576-13.751 10.005-8.671 18.554-4.413 21.578l-30.677 61.483-4.811-5.486-1.516-50.686z",
    fill: "#FAC864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.585 306.469l43.385-55.38 31.993.288 18.708 23.557c-2.813 8.747-11.863 28.719-16.036 37.612l-58.213 46.47-5.031-5.139 32.843-51.823m-47.649 4.415l1.516 50.686 4.811 5.486 30.677-61.483c-4.258-3.024-9.338-11.573 4.413-21.578 17.189-12.507 26.599 4.182 24.302 8.576-2.297 4.394-4.119 9.577-18.07 13.898m-47.649 4.415l4.591 5.835m43.058-10.25l4.81 5.486",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.396 311.954l43.385-55.38 31.992.288 18.709 23.556c-2.814 8.747-11.863 28.719-16.037 37.612l-63.244 41.332 32.843-51.824c13.951-4.321 15.773-9.503 18.071-13.898 2.297-4.394-7.114-21.083-24.303-8.576-13.75 10.005-8.671 18.555-4.412 21.578l-35.488 55.997-1.516-50.685z",
    fill: "#FFE496",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.79 247.354c6.993 13.357 22.403 25.148 38.039 30.185 4.592 1.479 9.203 2.375 13.627 2.558 9.743.402 16.731-2.735 20.152-8.133l102.625-161.936-73.066-46.305-102.625 161.935c-3.421 5.398-3.275 13.057 1.248 21.696z",
    fill: "#BDDCD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.829 277.539c4.592 1.479 9.203 2.375 13.627 2.558 9.743.402 16.731-2.735 20.152-8.133l102.625-161.936-73.066-46.305-102.625 161.935c-3.421 5.398-3.275 13.057 1.248 21.696 6.993 13.357 22.403 25.148 38.039 30.185zm0 0l102.133-161.157",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.89 185.66l77.276-121.937 73.066 46.305-77.276 121.938c-3.421 5.398-10.409 8.536-20.152 8.133-13.816-.57-29.463-8.105-40.625-18.599",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M337.298 88.367c9.113 17.406.587 30.859-19.044 30.048-19.63-.81-42.932-15.578-52.045-32.984-9.114-17.406-.588-30.859 19.043-30.048 19.631.81 42.932 15.578 52.046 32.984z",
    fill: "#BDDCD8",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.293 310.5l-4.5-4.5 43-55 4.5 6.5-43 53z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.947 83.56c7.764 14.829.5 26.29-16.225 25.6-16.724-.691-36.577-13.272-44.341-28.102-7.764-14.829-.5-26.29 16.224-25.6 16.725.69 36.578 13.272 44.342 28.101z",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M225.347 148.382c.264-14.232-6.978-31.26-17.401-42.909-3.06-3.421-6.395-6.378-9.894-8.664-7.708-5.036-14.755-5.864-19.918-3.132l-80.937 42.891 38.601 72.936 80.936-42.891c5.164-2.732 8.442-9.025 8.613-18.231z",
    fill: "#FAC864",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M205.437 158.67c.323-14.12-6.831-30.982-17.181-42.494-3.039-3.381-6.354-6.301-9.835-8.554-7.67-4.963-14.698-5.755-19.861-3.022l-63.498 32.714 38.207 72.192 63.498-32.714c5.163-2.733 8.461-8.989 8.67-18.122z",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.777 190.76c-.386 18.635-13.64 25.94-29.602 16.318-15.963-9.623-28.59-32.53-28.203-51.165.386-18.635 13.64-25.94 29.602-16.317 15.963 9.622 28.59 32.53 28.203 51.164z",
    fill: "#53978E",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.798 136.997c2.766.645 5.699 1.862 8.729 3.689 15.963 9.622 28.589 32.53 28.203 51.164-.07 3.37-.56 6.368-1.412 8.964-4.147.611-9.047-.538-14.266-3.684-14.461-8.717-25.899-29.469-25.549-46.35.123-5.938 1.688-10.605 4.295-13.783z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.798 136.997l.568-2.435a2.501 2.501 0 00-2.501.849l1.933 1.586zm8.729 3.689l1.291-2.141-1.291 2.141zm28.203 51.164l2.499.052-2.499-.052zm-1.412 8.964l.365 2.473a2.5 2.5 0 002.011-1.694l-2.376-.779zm-14.266-3.684l1.291-2.141-1.291 2.141zm-25.549-46.35l-2.5-.052 2.5.052zm3.727-11.348c2.472.576 5.163 1.68 8.006 3.395l2.582-4.282c-3.218-1.94-6.393-3.269-9.452-3.983l-1.136 4.87zm8.006 3.395c7.517 4.531 14.386 12.293 19.334 21.268 4.948 8.976 7.843 18.929 7.661 27.703l4.998.104c.205-9.86-3.02-20.678-8.28-30.22-5.26-9.543-12.685-18.046-21.131-23.137l-2.582 4.282zm26.995 48.971c-.066 3.161-.525 5.911-1.288 8.237l4.751 1.558c.939-2.865 1.461-6.113 1.535-9.691l-4.998-.104zm.723 6.543c-3.414.503-7.73-.41-12.611-3.352l-2.582 4.282c5.558 3.35 11.041 4.735 15.922 4.016l-.729-4.946zm-12.611-3.352c-6.766-4.079-12.963-11.075-17.43-19.179-4.467-8.105-7.074-17.08-6.911-24.978l-4.999-.104c-.186 8.983 2.751 18.824 7.531 27.495 4.78 8.671 11.532 16.409 19.227 21.048l2.582-4.282zm-24.341-44.157c.116-5.552 1.574-9.623 3.729-12.249l-3.866-3.172c-3.059 3.729-4.73 8.994-4.862 15.317l4.999.104z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.93 106.753a9.275 9.275 0 018.645 16.411l-76.675 40.39a4.207 4.207 0 01-1.115.399l-17.818 3.669c-4.138.852-6.817-4.235-3.775-7.165l13.104-12.62a4.22 4.22 0 01.959-.694l76.675-40.39z",
    fill: "#FAC864",
    stroke: "#000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgBloginline;